import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import ProcessLoader from "../ProcessLoader";
import { proxy } from '../../process/api';
import html2pdf from "html2pdf.js";

const createEmptyMR = (id) => ({
    id,
    mr_id: "",
    name: "",
    hq: "",
    priorities: ["", "", ""],
    communication_rating: "",
    advice: ["", "", ""],
    month_target: "",
    secondary_sales_as_on30: "",
    expected_sales_next_month: "",
    closing_stock_as_on30: ""
});

var visibleYear = "";
const emptyDoctorRow = () => ({
    doctor_name: "",
    speciality: "",
    dml_no: "",
    
    hq: "",
    town: "",
    brand: ""
});


const naturalMonths = [
    "JANUARY",
    "FEBRUARY",
    "MARCH",
    "APRIL",
    "MAY",
    "JUNE",
    "JULY",
    "AUGUST",
    "SEPTEMBER",
    "OCTOBER",
    "NOVEMBER",
    "DECEMBER"
];


const AB01VIEW = () => {
    const { draftid } = useParams();
    console.log(draftid);
    

      const [mrsList, setMrsList] = useState([]);
    const navigate = useNavigate();
      const [draftStatus, setDraftStatus] = useState('DRAFT');

    const mr_data = [{ "mr_id": 12, "mr_name": "AMIT" }, { "mr_id": 112, "mr_name": "AMITA" }, { "mr_id": 122, "mr_name": "ANKITA" }];
      const [mrAuditSheetStatus, setMrAuditSheetStatus] = useState([]);
    const [mrs, setMrs] = useState([]);
    const [doctors, setDoctors] = useState([]);
    const [header, setHeader] = useState([]);
    const [reportJSON, setReportJSON] = useState([]);
    const [showProcessLoader, setShowProcessLoader] = useState(true);
    const [showResetProcess, setshowResetProcess] = useState(false);


    const [mrData, setMrData] = useState([]);
    const [hqUsableName, setHqUsableName] = useState({});


    const doctorColumns = [
        { key: "doctor_name", label: "Name of Dr" },
        { key: "speciality", label: "Speciality" },
        { key: "dml_no", label: "DML No." },
      //  { key: "pcode", label: "P.Code" },
        { key: "hq", label: "HQ" },
        { key: "town", label: "Town" },
        { key: "brand", label: "Brand" },
    ];


    const loadABMReport = async () => {

        const abmAPIResponse = await proxy(`/api/mis/abm/report/${draftid}`, {}, "get");

        console.log(abmAPIResponse);
        setDoctors(abmAPIResponse?.doctors ?? []);
        setMrs(abmAPIResponse?.mrs ?? []);
        setHeader(abmAPIResponse?.header ?? []);
        setReportJSON(abmAPIResponse);
        setShowProcessLoader(false);

       


    }

    const getCurrentReport = async () => {
       
    
        const reportAPIreponse = await proxy(
          "/api/mis/abm/report/" + draftid,
          {},
          "get"
        );

         const mrAPIresponse = await proxy("/api/mis/psrlist?createdBy="+reportAPIreponse.report.created_by, {}, "get");
            setMrsList(mrAPIresponse?.data || []);
    
        setReportJSON(reportAPIreponse || {});
        setHeader(reportAPIreponse?.header || {});
        setDoctors(
          reportAPIreponse?.doctors?.length
            ? reportAPIreponse.doctors
            : Array.from({ length: 10 }, emptyDoctorRow)
        );
    
        setDraftStatus(reportAPIreponse.abm_draft_status.toUpperCase());
    
        if (Array.isArray(reportAPIreponse?.mrs) && reportAPIreponse.mrs.length) {
          setMrs(
            reportAPIreponse.mrs.map((mr, idx) => ({
              ...createEmptyMR(idx + 1),
              ...mr
            }))
          );
        } else {
          setMrs([createEmptyMR(1)]);
        }
    
    
        const auditMetaList = await handleAuditData(reportAPIreponse.audit_report_id, mrAPIresponse?.data);
        console.log(auditMetaList);
        setShowProcessLoader(false);
      };

        const handleAuditData = async (auditReportId, mrsList) => {
      
      
          const mrIds = (mrsList || [])
            .map((mr) => String(mr?.value ?? mr?.mr_id ?? "").trim())
            .filter(Boolean);
      
          if (!mrIds.length) {
            console.warn("No MR IDs available in mrsList");
            return [];
          }
      
          const auditMetaList = await Promise.all(
            mrIds.map(async (mrId) => {
              try {
                const meta = await proxy(
                  `/api/mis/abm/getauditreportmeta/${auditReportId}/${mrId}`,
                  {},
                  "get"
                );
                return { mr_id: mrId, meta, error: null };
              } catch (error) {
                console.error(`Failed for MR ID ${mrId}`, error);
                return { mr_id: mrId, meta: null, error };
              }
            })
          );
      
          const mrNameMap = new Map(
            (mrsList || []).map((mr) => [String(mr?.value ?? mr?.mr_id ?? ""), mr?.name || ""])
          );
      
          setMrAuditSheetStatus(
            auditMetaList.map((item) => {
              const innerSheetIds = Array.isArray(item?.meta?.auditInnerSheetIds)
                ? item.meta.auditInnerSheetIds
                : null;
      
              return {
                mr_id: item.mr_id,
                mr_name: mrNameMap.get(String(item.mr_id)) || "",
                status:
                  innerSheetIds && innerSheetIds.length === 0
                    ? "NOT_STARTED"
                    : innerSheetIds && innerSheetIds.length > 0
                      ? "HAS_AUDIT_SHEET"
                      : "UNKNOWN"
              };
            })
          );
      
      
          return auditMetaList;
        };

    useEffect(() => {
        setMrAuditSheetStatus((prev) => {
          const prevMap = new Map(
            prev.map((item, idx) => [String(item.mr_id || `row_${idx}`), item])
          );
    
          return (mrsList || []).map((mr, idx) => {
            const mrId = String(mr?.value || mr?.mr_id || `row_${idx}`);
            const existing = prevMap.get(mrId);
            return {
              mr_id: mrId,
              mr_name: mr?.name || "",
              status: typeof existing?.status === "string" ? existing.status : "UNKNOWN"
            };
          });
        });
      }, [mrsList]);

    useEffect(() => {
        getCurrentReport();
        loadABMReport();

        setMrData(Array.isArray(mr_data) ? mr_data : []);
        setHqUsableName("BHOPAL");
    }, []);

    const downloadPDF = () => {
        const element = document.getElementById("abm-report-01");

        if (!element) return;

        // const options = {
        //     margin: 5,
        //     filename: "ABM_REPORT.pdf",
        //     image: { type: "png", quality: 1 },
        //     html2canvas: {
        //         scale: 4,
        //         useCORS: true
        //     },
        //     jsPDF: {
        //         unit: "mm",
        //         format: "a4",
        //         orientation: "portrait"
        //     }
        // };
        const options = {
            margin: [18, 5, 22, 5],
            filename: "ABM-REPORT-"+(header?.fromName ? header.fromName.toUpperCase() : "") +
                            "-" +
                            naturalMonths[
                            Number(String(reportJSON?.report?.month).slice(4)) - 1
                            ] +
                            " " +
                            reportJSON?.report?.month.toString().slice(0,4)  +
                            "-" +
                            (header?.hq ? header.hq.toUpperCase() : "") +".pdf",
            image: { type: "jpeg", quality: 1 },
            html2canvas: {
                scale: 4,
                useCORS: true,
                letterRendering: true,
                scrollY: 0
            },
            jsPDF: {
                unit: "mm",
                format: "a4",
                orientation: "portrait"
            },
            pagebreak: {
                mode: ["avoid-all", "css", "legacy"]
            }
        };


        html2pdf()
            .set(options)
            .from(element)
            .toPdf()
            .get("pdf")
            .then((pdf) => {
                const totalPages = pdf.internal.getNumberOfPages();
                const pageWidth = pdf.internal.pageSize.getWidth();
                const pageHeight = pdf.internal.pageSize.getHeight();

                pdf.setFontSize(10);

                for (let i = 1; i <= totalPages; i++) {
                    pdf.setPage(i);

                    pdf.setFontSize(8);

                    const footerText =  naturalMonths[
                            Number(String(reportJSON?.report?.month).slice(4)) - 1
                            ] +
                            " " +
                           reportJSON?.report?.month.toString().slice(0,4) +
                            " - " +
                            (header?.hq ? header.hq.toUpperCase() : "") + ` -  Page ${i} of ${totalPages}`;
                    const footerWidth = pdf.getTextWidth(footerText);

                    pdf.text(
                        footerText,
                        (pageWidth - footerWidth) / 2,
                        pageHeight - 10
                    );

                    
                }
            })
            .save();
    };


    const addMR = () => {
        setMrs([...mrs, createEmptyMR(mrs.length + 1)]);
    };

    const updateMR = (index, field, value) => {
        const updated = [...mrs];
        updated[index][field] = value;
        setMrs(updated);
    };

    const updatePriority = (mrIdx, pIdx, value) => {
        const updated = [...mrs];
        updated[mrIdx].priorities[pIdx] = value;
        setMrs(updated);
    };

    const updateAdvice = (mrIdx, aIdx, value) => {
        const updated = [...mrs];
        updated[mrIdx].advice[aIdx] = value;
        setMrs(updated);
    };

    const addAdviceLine = (mrIdx) => {
        const updated = [...mrs];
        updated[mrIdx].advice.push("");
        setMrs(updated);
    };

    const handleMRSelect = (mrIdx, selectedMrId) => {
        const updated = [...mrs];
        const selected = mrData.find(
            (m) => String(m.mr_id) === String(selectedMrId)
        );

        updated[mrIdx].mr_id = selectedMrId || "";
        updated[mrIdx].name = selected?.mr_name || "";
        updated[mrIdx].hq = hqUsableName?.[selectedMrId] || "";

        setMrs(updated);
    };

    const updateDoctor = (row, field, value) => {
        const updated = [...doctors];
        updated[row][field] = value;
        setDoctors(updated);
    };

    const addDoctorRow = () => { 
        setDoctors([...doctors, emptyDoctorRow()]);
    };

    return (
        <div className="main-content">

            {showProcessLoader ? <ProcessLoader /> :



                <div className="row">
                    <div className="col-12">
                        <div className="card report-card">
                            <div className="card-title report-card-title">
                                ABM REPORT
                                <button
                                    className="btn btn-outline btn-sm mr-10 fw-500"
                                    onClick={() => navigate("/abm-report-01")}
                                >
                                    BACK
                                </button>

                                <button
                                    className="btn btn-outline btn-sm mr-10 fw-500 ml-2"
                                    onClick={downloadPDF}
                                >
                                    DOWNLOAD PDF
                                </button>


                            </div>

                            <div className="card-body">
                                <div id="abm-report-01" className="print">
                                    <div className="page">
                                        <div className="logo-area">
                                            <div
                                                style={{
                                                    display: "flex",
                                                    justifyContent: "center",
                                                    alignItems: "center"
                                                }}
                                            >
                                                <div className="">
                                                    <img src="/images/logo.png" style={{ filter: "grayscale(1)", maxWidth: "300px", marginBottom: "20px" }} />
                                                </div>
                                                <div>

                                                </div>
                                            </div>
                                        </div>

                                        <div className="title">Monthly Development Report - ABM</div>

                                        <div className="center-text">
                                            (Month : <span className="underline">
                                                {
                                                    naturalMonths[
                                                    Number(String(reportJSON?.report?.month).slice(4)) - 1
                                                    ]
                                                }&nbsp;
                                                
                                                {reportJSON?.report?.month.toString().slice(0,4) }
                                            </span>)
                                        </div>
                                        <div className="center-text">
                                            (To be submitted before 5<sup>th</sup> of every month)
                                        </div>

                                        <div className="info-box">
                                            <div className="info-grid">
                                                <div className="info-row">
                                                    <div className="label">From :</div>
                                                    <div>
                                                        <span className="bold">{header.fromName ? header.fromName.toUpperCase() : "__________"}</span> :&nbsp;
                                                        {header.designation ? header.designation.toUpperCase() : "__________"}
                                                    </div>
                                                </div>
                                                <div className="info-row">
                                                    <div className="label">TO :</div>
                                                    <div>{header?.to ? header.to.toUpperCase() : "__________"}</div>
                                                </div>

                                                <div className="info-row">
                                                    <div className="label">H.Q. :</div>
                                                    <div>{header?.hq ? header.hq.toUpperCase() : "__________"}</div>
                                                </div>

                                                <div className="info-row">
                                                    <div className="label">CC :</div>
                                                    <div>{header?.cc ? header.cc.toUpperCase() : "__________"}</div>
                                                </div>

                                                <div className="info-row">
                                                    <div className="label">DIV / BRANCH :</div><div>&nbsp;
                                                        {JSON.parse(localStorage.getItem('div_data')).data.find(depos => depos.value == reportJSON.report.div_code).name}&nbsp; / &nbsp;
                                                        {JSON.parse(localStorage.getItem('depo_data')).data.find(depos => depos.value == reportJSON.report.depo_code).name}
                                                    </div>
                                                </div>

                                                <div className="info-row">
                                                    <div className="label">DATE :</div>
                                                    <div>
                                                        {header.date
                                                            }

                                                    </div>
                                                </div>

                                            </div>   </div>

                                        <div className="staticText">

                                            <p>
                                                For each MR/PSR or FO/FSO reporting to you arrive at 3 priorities for the month by the 5th of the
                                                month. <strong style={{ textDecoration: "underline" }}>The 3 priorities should emerge out of Sales & Stock statement Analysis of top
                                                    contributing stockists of the Territory /HQ.</strong>
                                            </p>
                                            <p><strong>Guidelines of setting Priorities</strong></p>
                                            <ol>
                                                <li>Improve secondary sales of one Gold and one silver brand.</li>
                                                <li>Liquidation of near expiry stocks, so that the stocks don't reach the branch in an expired state.</li>
                                                <li>Preparing an accurate order for the subsequent month, which the ABM and Rep can follow through to get the desired primary from the stockist and in a way make a predictable primary closing.</li>
                                            </ol>

                                            <p><strong>Note :</strong> Report of {naturalMonths[
                                                Number(String(reportJSON?.report?.month).slice(4)) - 1
                                            ]
                                            }&nbsp;
                                               {reportJSON?.report?.month.toString().slice(0,4) } to be submitted by 5<sup>th</sup> of next month, so on & so forth.</p>
                                        </div>
                                        <div className="section-title">
                                            Top 3 Priorities for the month of each MR/PSR or FO/FSO of
                                            your team
                                        </div>

                                        {mrs && mrs.length > 0 ? (
                                            mrs.map((mr, idx) => (
                                                <div className="mr-block" key={mr.id}>
                                                    <div className="mr-header" style={{ fontWeight: 500 }}>
                                                        {idx + 1}) NAME OF THE MR / PSR OR FO / FSO{" "}
                                                        <strong style={{ fontWeight: 800 }}>
                                                            MR. {mr.name ? mr.name.toUpperCase() : "__________"}{" "}
                                                            H.Q. {mr.hq ? mr.hq.toUpperCase() : "__________"}
                                                        </strong>
                                                    </div>


                                                    {mr.priorities && mr.priorities.length > 0 ? (
                                                        mr.priorities.map((p, pIdx) => (
                                                            <div className="priority" key={pIdx}>
                                                                <span className="priority-label">
                                                                    {["I", "II", "III", "IV", "V", "VI", "VII", "VIII", "IX", "X"][pIdx] || `${pIdx + 1}`})
                                                                </span>

                                                                <span className="priority-text">
                                                                    {p ? p.toUpperCase() : "-"}
                                                                </span>

                                                                <div className="priority-line"></div>
                                                            </div>
                                                        ))
                                                    ) : (
                                                        <div className="priority-empty">NO PRIORITIES PROVIDED</div>
                                                    )}
                                                </div>
                                            ))
                                        ) : (
                                            <div>NO MR DATA AVAILABLE</div>
                                        )}




                                        <div className="section-title" style={{ marginTop: 35 }}>
                                            II) COMMUNICATION / DETAILING SKILL
                                        </div>
                                        <div>
                                            <p>Video detailing of the input decided for the month (as conveyed to you by your DBM / ZBM). Your team
                                                member needs to submit their video detailing to you & you should forward same to your RBM. Give your
                                                comments on Quality of Detailing of your Team member & write advise given.</p>
                                        </div>
                                        <table id="ratingTable">
                                            <thead>
                                                <tr>
                                                    <th>#</th>
                                                    <th>MR / PSR ID</th>
                                                    <th>NAME OF MR / PSR</th>
                                                    <th>HQ</th>
                                                    <th>COMMUNICATION RATING (1–10)</th>
                                                </tr>
                                            </thead>

                                            <tbody>
                                                {mrs && mrs.length > 0 ? (
                                                    mrs.map((mr, idx) => (
                                                        <tr key={mr.id}>
                                                            <td>{idx + 1}</td>
                                                            <td>{String(mr.mr_id).toUpperCase()}</td>
                                                            <td>{mr.name ? mr.name.toUpperCase() : "-"}</td>
                                                            <td>{mr.hq ? mr.hq.toUpperCase() : "-"}</td>
                                                            <td>
                                                                {mr.communication_rating
                                                                    ? String(mr.communication_rating).toUpperCase()
                                                                    : "-"}
                                                            </td>
                                                        </tr>
                                                    ))
                                                ) : (
                                                    <tr>
                                                        <td colSpan={5}>NO DATA AVAILABLE</td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </table>

                                        <p>
                                            # (Rating 10 as the highest & 1 as lowest)
                                        </p>
                                        <p>
                                            <strong>Self Rating :</strong>    _{reportJSON.self_assessment.self_rating}_
                                            &amp; <strong>Self Improvement Plan :</strong> _{reportJSON.self_assessment.self_improvement_plan}_
                                        </p>
                                        <div className="section-title" style={{ marginTop: 40 }}>
                                            ADVISE GIVEN TO EACH MR/PSR ON DETAILING IMPROVEMENT
                                        </div>

                                        {mrs && mrs.length > 0 ? (
                                            mrs.map((mr, idx) => (
                                                <div className="advice-block" key={mr.id}>
                                                    <div className="advice-header">
                                                        {idx + 1}) NAME OF THE MR / PSR OR FO / FSO{" "}
                                                        <strong style={{ fontWeight: 800 }}>
                                                            MR. {mr.name ? mr.name.toUpperCase() : "__________"}{" "}
                                                            H.Q. {mr.hq ? mr.hq.toUpperCase() : "__________"}
                                                        </strong>
                                                    </div>


                                                    {mr.advice && mr.advice.length > 0 ? (
                                                        <ul className="advice-list" style={{ listStyle: "upper-roman" }}>
                                                            {mr.advice.map((a, aIdx) => (
                                                                <li key={aIdx} style={{ borderBottom: "2px solid #000", paddingBottom: "5px", marginBottom: "10px" }}>



                                                                    <span className="priority-text" >  {a ? a.toUpperCase() : "-"}</span>

                                                                </li>
                                                            ))}
                                                        </ul>
                                                    ) : (
                                                        <div className="advice-empty">NO ADVICE PROVIDED</div>
                                                    )}
                                                </div>
                                            ))
                                        ) : (
                                            <div>NO MR DATA AVAILABLE</div>
                                        )}

                                        <div className="section-title" style={{ marginTop: 40 }}>
                                            III) It is expected that you develop New Prescribers preferably Consultants as a result of your own
                                            efforts.
                                            Mention herebelow the Doctors & the name of the Brand they have started prescribing.
                                        </div>

                                        <table id="doctorTable">
                                            <thead>
                                                <tr>
                                                    <th>#</th>
                                                    {doctorColumns.map((c) => (
                                                        <th key={c.key}>{c.label.toUpperCase()}</th>
                                                    ))}
                                                </tr>
                                            </thead>

                                            <tbody>
                                                {doctors.filter(d => d?.doctor_name && d.doctor_name.trim() !== "").length === 0 ? (
                                                    <tr>
                                                        <td colSpan={doctorColumns.length + 1}>NO DOCTORS FOUND</td>
                                                    </tr>
                                                ) : (
                                                    doctors
                                                        .filter(d => d?.doctor_name && d.doctor_name.trim() !== "")
                                                        .map((d, idx) => (
                                                            <tr key={idx}>
                                                                <td>{idx + 1}</td>

                                                                {doctorColumns.map((c) => (
                                                                    <td key={c.key}>
                                                                        {d?.[c.key]
                                                                            ? String(d[c.key]).toUpperCase()
                                                                            : "-"}
                                                                    </td>
                                                                ))}
                                                            </tr>
                                                        ))
                                                )}
                                            </tbody>

                                        </table>

                                        <div className="section-title" style={{ marginTop: 40 }}>
                                            CHEMIST AUDIT / MARKET SURVEY
                                        </div>

                                        <div className="staticText">
                                            <p>
                                                You are expected to conduct 4 comprehensive chemist audits every week. This will help you to obtain
                                                deep market knowledge about your operating geography. Read the guidelines on the chemist audit format
                                                & fill up 4 audits every week. Attach the audit report to this Monthly report.
                                            </p>
                                            <p>
                                                <strong>Monthly Chemist Audit Format attached</strong>
                                            </p>

                                        </div>

                                        <div className="section-title" style={{ marginTop: 40 }}>
                                            V) SALES UPDATE AND FORECAST (for Forthcoming Month)
                                        </div>

                                        <table id="salesTable">
                                            <thead>
                                                <tr>
                                                    <th>#</th>
                                                    <th style={{ width: "40mm" }}>NAME OF MR</th>
                                                    <th style={{ width: "35mm" }}>HQ</th>
                                                    <th>MONTH TGT</th>
                                                    <th>SEC SALES {naturalMonths[
                            Number(String(reportJSON?.report?.month).slice(4)) - 1
                            ].slice(0,3) }</th>
                                                    <th>CLOSING STOCK {naturalMonths[
                            Number(String(reportJSON?.report?.month).slice(4)) - 1
                            ].slice(0,3) }</th>
                                                    <th>EXPECTED SALES NEXT MONTH</th>
                                                </tr>
                                            </thead>

                                            <tbody>
                                                {mrs && mrs.length > 0 ? (
                                                    mrs.map((mr, idx) => (
                                                        <tr key={mr.id}>
                                                            <td>{idx + 1}</td>
                                                            <td>{mr.name ? mr.name.toUpperCase() : "-"}</td>
                                                            <td>{mr.hq ? mr.hq.toUpperCase() : "-"}</td>
                                                            <td>
                                                                {mr.month_target
                                                                    ? String(mr.month_target).toUpperCase()
                                                                    : "-"}
                                                            </td>
                                                            <td>
                                                                {mr.secondary_sales_as_on30
                                                                    ? String(mr.secondary_sales_as_on30).toUpperCase()
                                                                    : "-"}
                                                            </td>
                                                            <td>
                                                                {mr.closing_stock_as_on30
                                                                    ? String(mr.closing_stock_as_on30).toUpperCase()
                                                                    : "-"}
                                                            </td>
                                                            <td>
                                                                {mr.expected_sales_next_month
                                                                    ? String(mr.expected_sales_next_month).toUpperCase()
                                                                    : "-"}
                                                            </td>
                                                        </tr>
                                                    ))
                                                ) : (
                                                    <tr>
                                                        <td colSpan={7}>NO DATA AVAILABLE</td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </table>

                                        <p style={{ fontWeight: 800, textAlign: "right" }}>
                                            Sale value : Rs.in Lakhs
                                        </p>

                                        <div className="staticText">

                                            <p>
                                                <strong>#Note :</strong> Figures expected are for month in which report is submitted.<br />
                                                E.g. report dated 5
                                                th January - forecast expected for the month of January.
                                            </p>
                                            <p>
                                                <strong>Note :</strong>
                                                Enclose this Report along with your monthly TE Bill.

                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div className="d-flex justify-content-center align-items-center mb-5">


                    <div id="statusCheck">
                      <table className="table table-bordered mb-0">
                        <thead>
                          <tr>
                            <th style={{ width: "60px" }}>#</th>
                            <th>PSR</th>
                            <th>Audit Sheet Status</th>
                          </tr>
                        </thead>
                        <tbody>
                          {mrAuditSheetStatus.map((item, idx) => (
                            <tr key={`status_${item.mr_id || idx}`}>
                              <td>{idx + 1}</td>
                              <td>{item.mr_name || ""}</td>
                              <td>{item.status}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                    </div>
 <div className="d-flex justify-content-center align-items-center mb-5">
                    <button
                      className="btn btn-primary-outline btn-md ml-2"
                      onClick={async () => {
                         // waits
                     navigate("/abm-report-chemist-audit/" + reportJSON.audit_report_id+"/"+reportJSON.report?.created_by);
                      }}
                    >
                      View Chemist Audit Sheet 
                    </button>
                  </div>
                            </div>


                        </div>
                    </div>
                </div>
            }
        </div>
    );
};

export default AB01VIEW;
